export default "__VITE_ASSET__Q32vlzKf__"